import { apiClient } from "../../../services/apiClient";
import { KYC_API_KEY, KYC_DEFAULT_PROFILE_CODE } from "../../../services/endpoints";
import { CreateVerificationRequest, Verification } from "../types/session";

// Falls back to this literal only if the environment doesn't set
// REACT_APP_KYC_DEFAULT_PROFILE_CODE at all (see src/services/endpoints.ts).
const FALLBACK_PROFILE_CODE = "profile-basic";

export interface CreateVerificationSessionOptions {
  profileCode?: string | null;
  jurisdiction?: string | null;
}

// Requested profileCode wins; otherwise this environment's configured
// default (e.g. staging's "person-full"); otherwise the hardcoded fallback.
// Exported so the precedence can be tested without mocking the API call.
export function resolveProfileCode(requestedProfileCode?: string | null): string {
  return requestedProfileCode || KYC_DEFAULT_PROFILE_CODE || FALLBACK_PROFILE_CODE;
}

export async function createVerificationSession(
  applicantReference: string,
  options: CreateVerificationSessionOptions = {}
): Promise<Verification> {
  const { profileCode, jurisdiction } = options;

  const request: CreateVerificationRequest = {
    applicantReference,
    profileCode: resolveProfileCode(profileCode),
    integrationType: "FORM",
    ...(jurisdiction ? { context: { jurisdiction } } : {}),
  };

  const response = await apiClient.post<Verification>("/v1/verifications", request, {
    headers: {
      Authorization: `ApiKey ${KYC_API_KEY}`,
      "Idempotency-Key": crypto.randomUUID(),
    },
  });
  return response.data;
}
